import { instance } from "libs/api";

import { ApiRoutesSharing } from "../../constants";
import { CreateSharingScheduleBody } from "./createSharingSchedule.types";

export const requestCreateSharingSchedule = async (
  body: CreateSharingScheduleBody
): Promise<void> => {
  return await instance.post(ApiRoutesSharing.SharingSchedules, body);
};
